import Vuex from 'vuex'
import Vue from 'vue'
import latest from './modules/latest'
import user from './modules/user'
import index from './modules/index'
import events from './modules/events'
import preview from './modules/preview'
import history from './modules/history'
import starred from './modules/starred'
import received from './modules/received'
import team from './modules/team'
import {
  search,
  logout,
  loadConfig
} from '../store/service/common'

Vue.use(Vuex)
export default new Vuex.Store({
    modules:{
        latest,
        user,
        events,
        index,
        starred,
        preview,
        history,
        received,
        team
    },
    state() {
        return {
            locales: ['en', 'fr'],
            locale: 'en',
            baseUrl: '',
            messages: {},
            name: '',
            // flush timer
            timer: 0,
            // toast
            toastType: '',
            toastMsg: '',
            toastCount: 0,
            // dialog
            size: '',
            confirmInfo: '',
            dialogTitle: '',
            dialogShow: false,
            current: '',
            header: true,
            smodule: '',
            action: '',
            mutation: '',
            dialogIco: '',
            fileid: '',
            dialogData: {},
            extraData:{},
            // page loading
            pageloading: true,
            group: 0,
            autoGroup: 0,
            // route hilight
            route: '',
            // context menu
            contextMenuVisible: false,
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            contextData: {},
            // current select folder
            currentFolder: '',
            // upload
            parentid: 0,
            uploadConf: {},
            isFolder: false,
            frameUrl: '',
            // sort
            order: 'DESC',
            orderby: 'mtime',
            orderid: 2,

            searchList: [],
            hoverId: 0,
            listLoading: false,
            // team
            teamRoute: {},
            tid: 0,
            shareable: false
        }
    },
    mutations: {
        // lang
        SET_LANG(state, locale) {
            if (state.locales.indexOf(locale) !== -1) {
                state.locale = locale
                locale !== 'en' ? state.baseUrl = `/${locale}` : ''
            }
        },
        SAVE_MESSAGES(state, messages) {
            state.messages = messages
        },
        // timer
        UPDATE_TIME(state, s) {
            let cur = state.timer
            state.timer = cur >= 60 ? 0 : cur + s
        },
        // toast
        TOAST(state,{type,msg}){
            state.toastMsg = msg
            state.toastType = type
            state.toastCount = state.toastCount + 1
        },
        // dialog
        SHOW_DIALOG(state,{size,current,header,title,smodule,action,confirmInfo,dialogIco,fileid,mutation,dialogData}){
            state.size = size || 'small'
            state.dialogTitle = title
            state.confirmInfo = confirmInfo
            state.dialogShow = true
            state.current = current
            state.smodule = smodule || ''
            state.action = action || ''
            state.dialogIco = dialogIco || ''
            state.fileid = fileid || ''
            state.dialogData = dialogData || {}
            state.mutation = mutation || ''
            state.header = !header
        },
        SET_EXTRA(state,data){
            state.extraData = {
                ...state.extraData,
                ...data
            }
        },
        CLOSE(state){
            state.dialogShow = false
            state.extraData = {}
        },
        DIALOG_INIT(state){
            state.size = ''
            state.current = ''
            state.confirmInfo = ''
            state.dialogTitle = ''
            state.smodule = ''
            state.action = ''
            state.mutation = ''
            state.dialogIco = ''
            state.fileid = ''
            state.dialogData = {}
            state.header = false
        },
        // group info
        SAVE_GROUPS(state,{group,autoGroup}){
            state.group = group.type == 'special' ? group.id : autoGroup.id
            state.autoGroup = group.type == 'tmp' ? group.id : autoGroup.id
        },
        // route update
        UPDATE_ROUTE(state,paload){
            state.route = paload
        },
        // upload
        SAVE_PARENTID(state,pid){
            state.parentid = pid
        },
        SET_UPLOADTYPE(state,{type,data}){
            state.uploadConf = data || {}
            state.isFolder = type
        },
        // download
        UPDATE_URL(state, {url}) {
            state.frameUrl = url
        },
        // update sort
        UPDATE_SORT(state,{order,orderby,id}){
            state.order = order
            state.orderby = orderby
            state.orderid = id
        },
        SAVE_SEARCH(state,data){
            state.searchList = data.files
        },
        EMPTY_SEARCH(state){
            state.searchList = []
        },
        SHOW_CONTEXTMENU(state,{left,top,bottom,right,contextData}){
            state.left = left || 0
            state.top = top || 0
            state.bottom = bottom || 0
            state.right = right || 0
            state.contextMenuVisible = true
            state.contextData = contextData || {}
        },
        HIDE_CONTEXTMENU(state){
            state.left = 0
            state.right = 0
            state.top = 0
            state.bottom = 0
            state.contextData = {}
            state.contextMenuVisible = false
        },
        UPDATE_HOVER(state, fileid) {
          state.hoverId = fileid
        },
        LIST_LOADING(state,flag){
            state.listLoading = flag
        },
        SAVE_TEAM(state,paload){
            state.teamRoute = paload
        },
        UPDATE_TID(state,tid){
            state.tid = tid
        },
        SAVE_CONFIGS(state,data){
            state.shareable = data.shared
        }
    },
    getters:{

    },
    actions: {
        dosearch({commit},searchname){
            search(searchname,({status,data}) => {
                if (status === 200) {
                    commit('SAVE_SEARCH',data)
                }
            })
        },
        logout({commit},){
            logout({},({status,data}) => {
                if (status == 200) {
                    window.location.href = `https://account.wps.com?cb=${encodeURIComponent(window.location.href)}`
                }else{
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    })
                }
            })
        },
        flush({commit,dispatch},{action,smodule,paload}){
            dispatch(`${smodule}/${action}`, {
              noinit: true,
              ...paload
            })
        },
        close({commit,dispatch,state},){
            commit('CLOSE')
            setTimeout(() => {
                commit('DIALOG_INIT')
            }, 400);
        },
        loadConfig({commit,dispatch},){
            loadConfig(({status,data}) => {
                if (status == 200) {
                    this.commit("SAVE_CONFIGS",data)
                }
            })
        }
        
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js